import { StatsDetailsTabEnum } from '@/features/gateway/types'
import { lazy } from 'react'

const LazyStudentProfiles = lazy(() =>
  import('../StatsDetails/StudentProfiles').then((m) => ({
    default: m.StudentProfiles,
  }))
)

const LazyTotalTable = lazy(() =>
  import('../StatsDetails/StudentRecent/TotalTable').then((m) => ({
    default: m.TotalTable,
  }))
)

const LazyAttendanceTable = lazy(() =>
  import('../StatsDetails/StudentRecent/AttendanceTable').then((m) => ({
    default: m.AttendanceTable,
  }))
)

const LazyAbsenceTable = lazy(() =>
  import('../StatsDetails/StudentRecent/AbsenceTable').then((m) => ({
    default: m.AbsenceTable,
  }))
)

const LazyDeviceTable = lazy(() =>
  import('../StatsDetails/StudentRecent/DeviceTable').then((m) => ({
    default: m.DeviceTable,
  }))
)

const LazyStaticManagement = lazy(() =>
  import('../StatsDetails/StudentRecent/StaticManagement').then((m) => ({
    default: m.StaticManagement,
  }))
)

const LazyPunishmentTable = lazy(() =>
  import('../StatsDetails/StudentRecent/PunishmentTable').then((m) => ({
    default: m.PunishmentTable,
  }))
)

const LazyStudentPadUsageRecord = lazy(() =>
  import('../StatsDetails/StudentRecent/PadUsageRecord').then((m) => ({
    default: m.StudentPadUsageRecord,
  }))
)

const LazyStudentDailyAttendanceTable = lazy(() =>
  import('../StatsDetails/StudentRecent/StudentDailyAttendanceTable').then(
    (m) => ({
      default: m.StudentDailyAttendanceTable,
    })
  )
)

const LazyStudentTakeoutViolationTable = lazy(() =>
  import('../StatsDetails/StudentRecent/TakeoutViolationTable').then((m) => ({
    default: m.TakeoutViolationTable,
  }))
)

const LazyStudentLiftViolationTable = lazy(() =>
  import('../StatsDetails/StudentRecent/LiftViolationTable').then((m) => ({
    default: m.LiftViolationTable,
  }))
)

const LazyTeacherAttendanceTable = lazy(() =>
  import('../StatsDetails/TeacherRecent/TeacherAttendanceTable').then((m) => ({
    default: m.TeacherAttendanceTable,
  }))
)

const LazyCourseAssessmentItemDetails = lazy(() =>
  import('../StatsDetails/TeacherRecent/CourseAssessmentItemDetails').then(
    (m) => ({
      default: m.CourseAssessmentItemDetails,
    })
  )
)

const LazyAcademicSelectedSubjects = lazy(() =>
  import('../StatsDetails/AcademicStatistics/AcademicSelectedSubjects').then(
    (m) => ({
      default: m.AcademicSelectedSubjects,
    })
  )
)

const LazyAcademicCourseTasks = lazy(() =>
  import('../StatsDetails/AcademicStatistics/AcademicCourseTasks').then(
    (m) => ({
      default: m.AcademicCourseTasks,
    })
  )
)

const LazyAcademicExamGrades = lazy(() =>
  import('../StatsDetails/AcademicStatistics/AcademicExamGrades').then((m) => ({
    default: m.AcademicExamGrades,
  }))
)

const LazyAcademicCourseGrades = lazy(() =>
  import('../StatsDetails/AcademicStatistics/AcademicCourseGrades').then(
    (m) => ({
      default: m.AcademicCourseGrades,
    })
  )
)

const LazyAcademicAnalysis = lazy(() =>
  import('../StatsDetails/AcademicStatistics/AcademicAnalysis').then((m) => ({
    default: m.AcademicAnalysis,
  }))
)

// 枚举映射到懒加载组件
export const lazyComponentMap: Record<
  StatsDetailsTabEnum,
  React.LazyExoticComponent<React.FC>
> = {
  [StatsDetailsTabEnum.StudentProfiles]: LazyStudentProfiles,
  [StatsDetailsTabEnum.StudentOverview]: LazyTotalTable,
  [StatsDetailsTabEnum.StudentAttendance]: LazyAttendanceTable,
  [StatsDetailsTabEnum.StudentAbsence]: LazyAbsenceTable,
  [StatsDetailsTabEnum.StudentDeviceViolation]: LazyDeviceTable,
  [StatsDetailsTabEnum.StudentStaticManagement]: LazyStaticManagement,
  [StatsDetailsTabEnum.StudentPunishment]: LazyPunishmentTable,
  [StatsDetailsTabEnum.TeacherAttendance]: LazyTeacherAttendanceTable,
  [StatsDetailsTabEnum.CourseAssessmentItemDetails]:
    LazyCourseAssessmentItemDetails,
  [StatsDetailsTabEnum.AcademicSelectedSubjects]: LazyAcademicSelectedSubjects,
  [StatsDetailsTabEnum.AcademicCourseTasks]: LazyAcademicCourseTasks,
  [StatsDetailsTabEnum.AcademicExamGrades]: LazyAcademicExamGrades,
  [StatsDetailsTabEnum.AcademicCourseGrades]: LazyAcademicCourseGrades,
  [StatsDetailsTabEnum.StudentDailyAttendance]: LazyStudentDailyAttendanceTable,
  [StatsDetailsTabEnum.AcademicAnalysis]: LazyAcademicAnalysis,
  [StatsDetailsTabEnum.StudentPadUsageRecord]: LazyStudentPadUsageRecord,
  [StatsDetailsTabEnum.StudentTakeoutViolation]:
    LazyStudentTakeoutViolationTable,
  [StatsDetailsTabEnum.StudentLiftViolation]: LazyStudentLiftViolationTable,
}

/**
 * 根据用户 usin 获取读取所有按钮的类型
 *
 * @param usin - 用户 usin
 * @returns 读取所有按钮的类型
 */
export const getReadAllButtonType = (usin: string) => {
  // hack 只有平板管理权限，只展示平板违规统计卡片和平板管理的详情
  if (usin === 'bdfzlbq') {
    return StatsDetailsTabEnum.StudentPadUsageRecord
  }

  // hack 如果用户 usin 为 F0000G2206 ，则认为没有学生权限
  if (usin === 'F0000G2206') {
    return StatsDetailsTabEnum.TeacherAttendance
  }

  return StatsDetailsTabEnum.StudentProfiles
}
